module.exports = "<h2><a href=\"/admin\">Administration</a></h2>\n"